import RGL from "react-grid-layout";
import { useStore } from "../store";
import { WidgetCard } from "./WidgetCard";

// react-grid-layout v1 attaches WidthProvider to the default export at runtime.
// (Its @types use an `export =` namespace, so we access it off the default.)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const GridLayout: any = (RGL as any).WidthProvider(RGL);

/**
 * The widget grid.
 *
 * Read-only: the web build renders prebuilt report pages, so there is no drag,
 * resize or delete. Layout comes from the page definition rather than from
 * user state, which also means nothing to persist.
 */
export function DashboardCanvas() {
  const dashboard = useStore((s) => s.dashboard);

  const layout = dashboard.widgets.map((w) => ({ i: w.id, ...w.layout, static: true }));

  return (
    <div className="canvas-scroll">
      <GridLayout
        className="layout"
        layout={layout}
        cols={12}
        rowHeight={60}
        margin={[12, 12]}
        isDraggable={false}
        isResizable={false}
      >
        {dashboard.widgets.map((w) => (
          <div key={w.id} className="grid-item">
            <WidgetCard widget={w} />
          </div>
        ))}
      </GridLayout>
    </div>
  );
}
